import { render, staticRenderFns } from "./NotifyMeal.vue?vue&type=template&id=ca225fec"
import script from "./NotifyMeal.vue?vue&type=script&lang=js"
export * from "./NotifyMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports